<template>
    <div class="form-group row align-items-center">
        <label class="col-md-2 mb-md-0 required"> {{ $t('city') }} </label>
        <app-input 
            class="col-md-8 mt-2 pt-1" 
            :placeholder="$t('select_city_phd')"
            type="advance-search-select" 
            :fetch-url='`/states/${state_id}/cities`'
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5" 
        />
    </div>
</template>
 
<script>
    export default {
        name: 'CustomerState',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            state_id: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>